import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { socketConnection } from "../../services/socket";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
    const [qrCode, setQrCode] = useState("");
    const [timer, setTimer] = useState(60);

    useEffect(() => {
        const fetchSession = async () => {
            if (!whatsAppId) return;

            try {
                const { data } = await api.get(`/whatsapp/${whatsAppId}`);
                setQrCode(data.qrcode);
            } catch (err) {
                toastError(err);
            }
        };
        fetchSession();
    }, [whatsAppId]);

    useEffect(() => {
        if (!whatsAppId || !open) return;

        const interval = setInterval(async () => {
            try {
                await api.get(`/whatsappsession/${whatsAppId}`);
            } catch (err) {
                console.error(err);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [whatsAppId, open]);

    useEffect(() => {
        if (!whatsAppId || !open || !qrCode) return;

        const countdownInterval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    handleRegenerateQr();
                    return 60;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(countdownInterval);
    }, [whatsAppId, open, qrCode]);

    const handleRegenerateQr = async () => {
        try {
            await api.put(`/whatsappsession/${whatsAppId}`);
        } catch (err) {
            toastError(err);
        }
    };

    useEffect(() => {
        if (!whatsAppId) return;
        const companyId = localStorage.getItem("companyId");
        const socket = socketConnection({ companyId });

        socket.on(`company-${companyId}-whatsappSession`, (data) => {
            if (data.action === "update" && data.session.id === whatsAppId) {
                setQrCode(data.session.qrcode);
                if (data.session.qrcode !== "") {
                    setTimer(60); // Reset timer when a new QR code is received
                }
            }

            if (data.action === "update" && data.session.status === "CONNECTED") {
                onClose();
            }

            if (data.action === "update" && data.session.qrcode === "" && data.session.status !== "qrcode") {
                onClose();
            }
        });

        return () => {
            socket.disconnect();
        };
    }, [whatsAppId, onClose]);

    const renderQrCode = () => {
        if (qrCode.startsWith("data:image")) {
            return (
                <img
                    src={qrCode}
                    alt="QR Code"
                    style={{
                        width: 350,
                        height: 350,
                        padding: 10,
                        backgroundColor: "#fff",
                    }}
                />
            );
        }
        return (
            <QRCode
                value={qrCode}
                size={350}
                style={{
                    padding: 30,
                    backgroundColor: "#fff",
                }}
            />
        );
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
            <DialogContent>
                <Paper elevation={0}>
                    <Typography color="primary" gutterBottom>
                        {i18n.t("qrCode.message")}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" align="center" style={{ marginBottom: 10 }}>
                        O QR Code será atualizado em: <strong>{timer}s</strong>
                    </Typography>
                    {qrCode ? (
                        renderQrCode()
                    ) : (
                        <span>Waiting for QR Code</span>
                    )}
                </Paper>
            </DialogContent>
        </Dialog>
    );
};

export default React.memo(QrcodeModal);
